import styles from './LoadingLines.module.scss';

interface LoadingLinesProps {
  lines?: number;
  className?: string;
}

export const LoadingLines = ({ lines = 3, className }: LoadingLinesProps) => {
  const widths = ['60%', '80%', '45%', '90%', '70%'];

  return (
    <div className={`${styles.loadingLines} ${className || ''}`}>
      {Array.from({ length: lines }).map((_, index) => (
        <div
          key={index}
          className={styles.line}
          style={
            {
              width: widths[index % widths.length],
              '--animation-delay': `${index * 100}ms`,
            } as React.CSSProperties
          }
        />
      ))}
    </div>
  );
};
